<template>
    <div class="home" id="con">
        <div class="home-child-left">
            <div class="header">
                <div class="header-sideone">
                    <img src="//s.thsi.cn/js/zijinquanxi/assets/pc/hgicon.png" width="24px" height="24px" style="vertical-align: middle" />
                    <span style="vertical-align: middle; color: #0096ff; margin-left: 10px">宏观数据-宏观流动性</span>
                </div>
                <div class="guide" style="font-size: 16px; top: auto">
                    <div class="goGuide" @click="goGuide()">一图看懂宏观流动性</div>
                    <transition name="fade">
                        <div v-if="highlight" class="goGuide2" @click="goGuide()">一图看懂宏观流动性</div>
                    </transition>
                </div>
                <div class="comment" @click="commentClick()"></div>
                <div class="container">
                    <div id="content">
                        <div class="likes" style="font-size: 14px; top: auto; left: 20px">
                            <div class="button-text" style="color: #f7107e; font-weight: bold">喜欢的话点个赞吧~</div>
                            <div id="btn-like" class="buttons">
                                <i class="icon-like stat_operate" stat_type="support" style="color: #f7107e"></i><span id="like-num" class="stat_number" stat_type="support" style="color: #000"></span>
                            </div>
                            <div id="btn-unlike" class="buttons">
                                <i class="icon-unlike stat_operate" stat_type="opposition" style="color: #f7107e"></i
                                ><span id="unlike-num" class="stat_number" stat_type="opposition" style="color: #000"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="header-content">
          <div style="display:flex;align-items: center;">
            <div class="blue"></div>
            <p>低估： 升值空间大</p>
          </div>
          <div style="display:flex;align-items: center;">
            <div class="yellow"></div>
            <p>适中： 请注意风险</p>
          </div>
          <div style="display:flex;align-items: center;">
            <div class="red"></div>
            <p>高估： 可持续关注</p>
          </div>
        </div> -->
            </div>
            <div class="box-wrap" style="background-color: #202126; height: 340px">
                <div class="box" style="width: 33%">
                    <div class="box-child-wrap">
                        <div class="box-child">
                            <vue-loading v-if="firstloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                            <HGOverview :today="column1Data.date" :HGTodayData="column1Data.HGTodayData" :HGOverview="column1Data.HGOverview"></HGOverview>
                        </div>
                    </div>
                </div>
                <div class="box" style="width: 37%">
                    <div class="box-child-wrap">
                        <div class="box-child">
                            <vue-loading v-if="firstloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                            <LogicDetail :drawData="column1Data.logicDetail"></LogicDetail>
                        </div>
                    </div>
                </div>
                <div class="box" style="width: 20%">
                    <div class="box-child-wrap">
                        <div class="box-child">
                            <vue-loading v-if="firstloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                            <HGConclusion :HGConclusion="column1Data.HGConclusion"></HGConclusion>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-wrap" style="height: 400px; padding: 20px 0">
                <div class="box">
                    <div class="box-child-wrap">
                        <div class="box-child">
                            <vue-loading v-if="secondloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                            <SZValues
                                :SHEstimation="column2Data.SHEstimation"
                                :ispedangerprop="ispedangerprop"
                                :ispbdangerprop="ispbdangerprop"
                                :SHValuationSeries="column2Data.SH_valuation_series"
                                :SHPBSeries="column2Data.SH_PBSeries"
                            ></SZValues>
                        </div>
                    </div>
                </div>
                <div class="box">
                    <div class="box-child-wrap">
                        <div class="box-child">
                            <vue-loading v-if="secondloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                            <HSValues :dualMarketValue="column2Data.dualMarketValue" :SHSZvalueseries="column2Data.SH_SZ_value_series"></HSValues>
                        </div>
                    </div>
                </div>
                <div class="box">
                    <div class="box-child-wrap">
                        <div class="box-child">
                            <vue-loading v-if="secondloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                            <PieAndLine :M1="column2Data.M1" :DR007="column2Data.DR007" :M1Series="column2Data.M1Series"></PieAndLine>
                        </div>
                    </div>
                </div>
            </div>

            <div style="font-size: 24px; color: #0096ff; padding: 22px 20px 20px; margin-top: 35px">
                <img src="//s.thsi.cn/js/zijinquanxi/assets/pc/zgicon.png" width="24px" height="24px" style="vertical-align: middle" />
                <span style="vertical-align: middle; color: #0096ff; margin-left: 10px">中观数据-中观流动性</span>
            </div>

            <template>
                <div class="box-wrap" style="background-color: #202126">
                    <div class="box" style="width: 48%">
                        <div class="box-child-wrap">
                            <div class="box-child">
                                <vue-loading v-if="thirdloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                                <ZGOverview :today="column1Data.date" :ZGTodayData="column3Data.ZGTodayData" :ZGOverview="column3Data.ZGOverview"></ZGOverview>
                            </div>
                        </div>
                    </div>
                    <div class="box" style="width: 26%">
                        <div class="box-child-wrap">
                            <div class="box-child">
                                <vue-loading v-if="thirdloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                                <ZGLogicDetail :ZGTodayData="column3Data.ZGTodayData"></ZGLogicDetail>
                            </div>
                        </div>
                    </div>
                    <div class="box" style="width: 19%">
                        <div class="box-child-wrap">
                            <div class="box-child">
                                <vue-loading v-if="thirdloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                                <ZGConclusion :ZGConclusion="column3Data.ZGConclusion"></ZGConclusion>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="box-wrap" style="height: 430px; padding: 20px 0">
                    <div class="box">
                        <div class="box-child-wrap">
                            <div class="box-child">
                                <vue-loading v-if="thirdloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                                <LGT :lgtLiquiditySeries="column4Data.lgtLiquiditySeries" :lgtLiquidity="column4Data.lgtLiquidity"> </LGT>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-child-wrap">
                            <div class="box-child">
                                <vue-loading v-if="thirdloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                                <LeveragedFunds :leverageMoney="column4Data.leverageMoney" :leverageMoneySeries="column4Data.leverageMoneySeries"> </LeveragedFunds>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-child-wrap">
                            <div class="box-child">
                                <vue-loading v-if="thirdloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                                <DBCapital :catchMoney="column4Data.catchMoney" :catchMoneySeries="column4Data.catchMoneySeries"> </DBCapital>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-wrap" style="height: 430px; padding: 20px 0">
                    <div class="box">
                        <div class="box-child-wrap">
                            <div class="box-child">
                                <vue-loading v-if="fifthloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                                <DZCapital :fixedIncreaseMoney="column5Data.fixedIncreaseMoney" :fixedIncreaseMoneySeries="column5Data.fixedIncreaseMoneySeries"> </DZCapital>
                            </div>
                        </div>
                    </div>

                    <div class="box">
                        <div class="box-child-wrap">
                            <div class="box-child">
                                <vue-loading v-if="fifthloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                                <JCCapital :fixedIncreaseMoney="column5Data.fixedIncreaseMoney" :reductionMoneySeries="column5Data.reductionMoneySeries"> </JCCapital>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-child-wrap">
                            <div class="box-child">
                                <vue-loading v-if="fifthloading" type="bars" color="#d9544e" :size="{ width: '50px', height: '50px' }"></vue-loading>
                                <IPO :IPO="column5Data.IPO" :IPO_series="column5Data.IPO_series"> </IPO>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="home-child-right"></div>
        <div class="home-bottom">
            <p>【本产品数据基于历史，模型和测试；本页面内容概不构成任何投资建议，需要投资者根据不同行情合理运用、独立判断、控制风险。股市有风险，投资需谨慎！】</p>
            <p>浙江核新同花顺网络信息股份有限公司@版权所有</p>
            <p>Zhejiang RoyalFlush cloud software co.,LTD.All rights reserved.</p>
            <p>证券资讯服务提供：浙江同花顺云软件有限公司</p>
            <p>[编号：ZX0050]</p>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

// import Navigation from "@/components/Navigation.vue";
import HGOverview from '@/components/HGOverview.vue'
import LogicDetail from '@/components/LogicDetail.vue'
import HGConclusion from '@/components/HGConclusion.vue'
import SZValues from '@/components/SZValues.vue'
import HSValues from '@/components/HSValues.vue'
import PieAndLine from '@/components/PieAndLine.vue'
import ZGOverview from '@/components/ZGOverview.vue'
import ZGLogicDetail from '@/components/ZGLogicDetail.vue'
import ZGConclusion from '@/components/ZGConclusion.vue'
import LGT from '@/components/LGT.vue'
import LeveragedFunds from '@/components/LeveragedFunds.vue'
import DBCapital from '@/components/DBCapital.vue'
import DZCapital from '@/components/DZCapital.vue'
import JCCapital from '@/components/JCCapital.vue'
import IPO from '@/components/IPO.vue'

// import SeesawPane from "@/components/SeesawPane.vue";
import { VueLoading } from 'vue-loading-template'
export default {
    name: 'screen',
    components: {
        HGOverview,
        LogicDetail,
        HGConclusion,
        SZValues,
        HSValues,
        PieAndLine,
        ZGOverview,
        ZGLogicDetail,
        ZGConclusion,
        LGT,
        LeveragedFunds,
        DBCapital,
        DZCapital,
        IPO,
        JCCapital,
        // SeesawPane,
        VueLoading,
    },
    computed: {
        debugBackground() {
            return this.$store.state.debugBackground
        },
    },
    data() {
        return {
            column1Data: {},
            column2Data: {},
            column3Data: {},
            column4Data: {},
            column5Data: {},
            ispedangerprop: '',
            ispbdangerprop: '',
            peQuantile: '',
            pbQuantile: '',
            firstloading: true,
            secondloading: true,
            thirdloading: true,
            fourthloading: true,
            fifthloading: true,
            highlight: false,
            isFirst: true,
            showComment: false,
            clock: 0,
            times: 0,
        }
    },
    watch: {},
    mounted() {
        this.evaluation()
        this.enterPage()
        // 第1行数据
        this.$api.blockAPI
            .gethongguanldx()
            .then((res) => {
                if (res.code === 0) {
                    this.column1Data = res.data
                    this.firstloading = false
                } else {
                    console.log('第1行数据获取异常')
                }
            })
            .catch((e) => {})

        // 第2行数据
        this.$api.blockAPI
            .getsecondColumnChart()
            .then((res) => {
                if (res.code === 0) {
                    this.column2Data = res.data
                    if (this.column2Data.SHEstimation.PE.value < this.column2Data.SHEstimation.PE.quantile[0]) {
                        this.ispedangerprop = '风险低'
                        this.peQuantile = '较低位置'
                    } else if (this.column2Data.SHEstimation.PE.value > this.column2Data.SHEstimation.PE.quantile[1]) {
                        this.ispedangerprop = '风险高'
                        this.peQuantile = '较高位置'
                    } else {
                        this.ispedangerprop = '风险适中'
                        this.peQuantile = '适中位置'
                    }
                    if (this.column2Data.SHEstimation.PB.value < this.column2Data.SHEstimation.PB.quantile[0]) {
                        this.ispbdangerprop = '风险低'
                        this.pbQuantile = '较低位置'
                    } else if (this.column2Data.SHEstimation.PB.value > this.column2Data.SHEstimation.PB.quantile[1]) {
                        this.ispbdangerprop = '风险高'
                        this.pbQuantile = '较高位置'
                    } else {
                        this.ispbdangerprop = '风险适中'
                        this.pbQuantile = '适中位置'
                    }
                    this.secondloading = false
                } else {
                    console.log('第2行数据获取异常')
                }
            })
            .catch((e) => {})
        // 第3行数据
        this.$api.blockAPI
            .getthirdcolumn()
            .then((res) => {
                if (res.code === 0) {
                    this.column3Data = res.data
                    this.thirdloading = false
                } else {
                    console.log('第3行数据获取异常')
                }
            })
            .catch((e) => {})
        // 第4行数据
        this.$api.blockAPI
            .getFourthcolumn()
            .then((res) => {
                if (res.code === 0) {
                    this.column4Data = res.data
                    this.fourthloading = false
                } else {
                    console.log('第4行数据获取异常')
                }
            })
            .catch((e) => {})
        // 第5行数据
        this.$api.blockAPI
            .getFifthcolumn()
            .then((res) => {
                if (res.code === 0) {
                    this.column5Data = res.data
                    this.fifthloading = false
                } else {
                    console.log('第5行数据获取异常')
                }
            })
            .catch((e) => {})
        let that = this
        // 当首次进入时
        this.clock = setInterval(function () {
            that.times++
            if (that.times >= 8) {
                clearInterval(that.clock)
            } else {
                that.highlight = !that.highlight
            }
        }, 1200)
        this.firstRead(this.clock, this)
    },
    methods: {
        evaluation() {
            var options = {
                app: 6, // 应用
                key: 16, // 键名
                token: '7f15fe0d44', // 令牌，用于验证app和key是否有效
                supportBtn: '.stat_operate[stat_type=support]', // 支持按钮的选择器
                supportNum: '.stat_number[stat_type=support]', // 支持数量的选择器
                haveSupported: 'disable', // 已支持过的样式
                watchBtn: '.stat_operate[stat_type=watch]', // 围观按钮的选择器
                watchNum: '.stat_number[stat_type=watch]', // 围观数量的选择器
                haveWatched: 'disable', // 已围观过的样式
                oppositionBtn: '.stat_operate[stat_type=opposition]', // 反对按钮的选择器
                oppositionNum: '.stat_number[stat_type=opposition]', // 反对数量的选择器
                haveOpposited: 'disable', // 已反对过的样式
            }
            $('.likes').evaluate(options)
        },
        enterPage() {
            try {
                TA.log({ id: 'pcweb_hgdata' })
            } catch (e) {}
        },
        goGuide() {
            if (this.isFirst) {
                this.firstWrite()
                this.isFirst = false
            }
            setTimeout(function () {
                window.location.href = '//zx.10jqka.com.cn/fundholo/public/guide.html'
            }, 300)
        },
        commentClick() {
            if (this.showComment) {
                this.showComment = false
                $('#content').css('left', '300px')
            } else {
                this.showComment = true
                $('#content').css('left', '0')
            }
        },
        firstWrite() {
            console.log('开始写入文件！')
            window.API.use({
                method: 'external.getUserPath',
                success: function (data) {
                    let thsExammarketPath = data + 'zijinquanxi_operation.log'
                    window.API.use({
                        method: 'fileWriter.open',
                        data: thsExammarketPath,
                        success: function () {
                            window.API.use({
                                method: 'fileWriter.write',
                                data: '1',
                                success: function (str) {
                                    window.API.use({
                                        method: 'fileWriter.close',
                                        success: function (data) {
                                            console.log('写入文件成功！')
                                        },
                                    })
                                },
                            })
                        },
                    })
                },
            })
        },
        firstRead(clock, that) {
            window.API.use({
                method: 'external.getUserPath',
                success: function (data) {
                    let thsExammarketPath = data + 'zijinquanxi_operation.log'
                    window.API.use({
                        method: 'fileReader.open',
                        data: thsExammarketPath,
                        success: function (d) {
                            if (!d) {
                                return
                            }
                            window.API.use({
                                method: 'fileReader.read',
                                success: function (str) {
                                    if (str) {
                                        clearInterval(clock)
                                        that.highlight = false
                                        that.isFirst = false
                                        console.log('判断为已经查看过了')
                                    }
                                    window.API.use({
                                        method: 'fileReader.close',
                                        success: function (data) {},
                                    })
                                },
                            })
                        },
                    })
                },
            })
        },
    },
}
</script>

<style scoped>
#con {
}
.home {
    position: relative;
    min-width: 1200px;
    /*display: flex;*/
    /*justify-content: flex-end;*/
}
.home-child-left {
    /*为右侧导航栏预留*/
    /*margin-right: 180px;*/
    padding: 0 20px 20px 20px;
}
.home-child-right {
    width: 178px;
    display: block;
    top: 0;
    right: 0;
    position: fixed;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    display: none;
}

.box-wrap {
    width: 100%;
    display: flex;
    height: 292px;
    padding: 20px;
    justify-content: space-between;
}
.box {
    width: 32%;
    position: relative;
}
.box-child-wrap {
    display: flex;
    justify-content: space-around;
}
.box-child {
    width: 100%;
}
.header {
    display: flex;
    height: 70px;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    padding: 10px 0 10px 20px;
}
.header-content {
    display: flex;
    font-size: 12px;
    justify-content: space-between;
    height: 15px;
    width: 400px;
    align-items: center;
}
.blue {
    background-color: #0096ff;
    width: 8px;
    height: 8px;
    margin: 5px;
}
.yellow {
    background-color: #d1b80f;
    width: 8px;
    height: 8px;
    margin: 5px;
}
.red {
    background-color: #fd4332;
    width: 8px;
    height: 8px;
    margin: 5px;
}
.home-bottom {
    height: 128px;
    display: flex;
    font-size: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #121315;
}
.home-bottom p {
    line-height: 16px;
}
.home-bottom p:first-child {
    margin-bottom: 10px;
}
.vue-loading {
    position: absolute;
    top: 50%;
    left: 40%;
    z-index: 9999;
}
#l-tip {
    left: 25px !important;
}
.guide {
    position: absolute;
    top: 0 !important;
    right: 27px;
    height: 40px;
    margin-top: 15px;
    width: 180px;
    padding-left: 10px;
    background-color: #3b3c41;
    text-align: center;
}
.goGuide {
    position: absolute;
    width: 160px;
    cursor: pointer;
    color: #fff;
    opacity: 0.5;
    line-height: 40px;
}
.goGuide2 {
    position: absolute;
    width: 160px;
    margin-right: 14px;
    cursor: pointer;
    color: #fff;
    line-height: 40px;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
.comment {
    position: fixed;
    right: 12px;
    bottom: 60px;
    width: 40px;
    height: 40px;
    background: url('//s.thsi.cn/js/datavproject/zijinquanxi_guide/comment.png');
    z-index: 100001;
    cursor: pointer;
}
.container {
    position: fixed;
    right: 32px;
    bottom: 60px;
    width: 300px;
    height: 40px;
    z-index: 100000;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0);
}
#content {
    position: relative;
    left: 300px;
    width: 300px;
    height: 40px;
    border-radius: 20px 0 0 20px;
    background-color: #fff;
    /* background: radial-gradient(circle at 300px 20px, transparent 20px, #fff 20px) right top; */
    color: #f7107e;
    z-index: 9998;
    line-height: 40px;
    -webkit-transition: 1s;
    -moz-transition: 1s;
    -ms-transition: 1s;
    -o-transition: 1s;
    transition: 1s;
}
.icon-like {
    display: inline-block;
    width: 17px;
    height: 17px;
    position: relative;
    top: 2px;
    margin-right: 5px;
    margin-left: 10px;
    background: url('//s.thsi.cn/js/datavproject/zijinquanxi_guide/like.png');
}
.icon-unlike {
    display: inline-block;
    width: 17px;
    height: 17px;
    position: relative;
    top: 4px;
    margin-left: 10px;
    margin-right: 5px;
    background: url('//s.thsi.cn/js/datavproject/zijinquanxi_guide/unlike.png');
}
</style>
